import { getModule } from 'vuex-module-decorators'

import Auth from './auth'
import Center from './center'
import Doctor from './doctor'
import Patient from './patient'
import DrugGroup from './drug_group'

export const auth = getModule(Auth)
export const center = getModule(Center)
export const doctor = getModule(Doctor)
export const patient = getModule(Patient)
export const drug_group = getModule(DrugGroup)
